import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent implements OnInit {

  @Input() wholeElementId: string;
  @Input() labelText: string = 'Label';
  @Input() optionsList: any[] = [];
  @Input() externalStyles: ExternalStylesCustomSelect;
  @Output() onOpen = new EventEmitter<boolean>();
  @Input() optionTransformer: (option: any) => string | number = (option) => option;
  @Input() selectedOption: any;
  @Output() selectedOptionChange = new EventEmitter<any>();

  private _isVisible: boolean = false;

  public elementsIdentifiers = {
    wholeElementId: '',
    valueContainerId: 'valueContainerId',
    labelId: 'labelId',
    selectedValueId: 'selectedValueId',
    iconContainerId: 'iconContainerId',
    backDropId: 'backDropId',
    singleOptionId: 'singleOptionId',
  }

  private _classesNames =  {
    labelClose: 'labelStyle',
    labelOpen: 'labelOpenStyle',
    iconInitial: 'iconInitialStyle',
    iconRotated: 'iconRotatedStyle',
  }

  ngOnInit() {
    Object.keys(this.elementsIdentifiers).forEach((key) => {
      this.elementsIdentifiers[key] = `${this.elementsIdentifiers[key]}${this.wholeElementId}`;
    });
  }
  constructor() { }

  optionClickHandler($event) {

  }

  hasSelectedOption(): boolean {
    return !!this.selectedOption;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  set isVisible(value: boolean) {
    this._isVisible = value;
  }

  close() {
    this.isVisible = false;
    this.onOpen.emit(false);
  }

  open() {
    this.isVisible = true;
    this.onOpen.emit(true);
  }

  elementClickHandler($event) {
    const index = $event.target.tabIndex - 1;
    if (this.optionsList[index]) {
      this.selectedOptionChange.emit(this.optionsList[index])
    }
    if (this.isVisible) {
      this.close();
      return;
    }

    this.open();
  }

  labelStyles() {
    return {
      [this._classesNames.labelOpen]: this.isVisible || this.hasSelectedOption(),
    }
  }

  iconStyles() {
    return {
      [this._classesNames.iconRotated]: this.isVisible,
      [this._classesNames.iconInitial]: !this.isVisible,
    }
  }

}

export interface ExternalStylesCustomSelect {
  elementWrapperStyle?: {
    width?: string,
    height?: string,
    border?: string,
    borderRadius?: string,
  },
  iconContainerStyle?: {
    borderLeft?: string,
  }
  optionsWrapperStyle?: {
    boxShadow?: string,
    padding?: string,
    animation?: string,
    borderRadius?: string,
  },
  singleOptionWrapper?: {
    padding?: string,
  }
}
